"use client";

import { signIn, signOut, useSession } from "next-auth/react";

import React, { useEffect } from "react";

import { MdLogout } from "react-icons/md";
import { FaHome } from "react-icons/fa";
import { API_USR_URL } from "@/lib/constant";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useRouter } from "next/navigation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./dialog";
import { Button } from "./button";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "./dropdown-menu";
import { IoIosHelpCircle } from "react-icons/io";

function getInitials(name) {
  if (!name) return "User";
  return name
    .split(" ")
    .map((part) => part[0].toUpperCase())
    .join("");
}

const roleCheckPaths = [
  { path: "/admin/sekretariat", roleIds: [40] },
  { path: "/mitra", roleIds: [3] },
  { path: "/admin/assessor", roleIds: [42] },
  { path: "/admin/penilai-akhir", roleIds: [43] },
  { path: "/admin/evaluator", roleIds: [44] },
  { path: "/admin/super-admin", roleIds: [1] },
];
export default function SignInButton() {
  const { data: session, status } = useSession();
  const router = useRouter();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleDashboardClick = () => {
    const userRoleId = session.roles;

    const priorityRoles = [40, 42, 43, 44, 1, 3];

    const sortedRoleCheckPaths = roleCheckPaths.sort(
      ({ roleIds: a }, { roleIds: b }) => {
        const aIndex = a.find((roleId) => priorityRoles.includes(roleId));
        const bIndex = b.find((roleId) => priorityRoles.includes(roleId));
        return priorityRoles.indexOf(aIndex) - priorityRoles.indexOf(bIndex);
      }
    );

    const path = sortedRoleCheckPaths.find(({ roleIds }) =>
      roleIds.some((roleId) => userRoleId.includes(roleId))
    )?.path;

    if (path) {
      window.location.href = "/akreditasi" + path;
      // router.push(path);
    } else {
      console.error("User role not found in roleCheckPaths");
    }
  };

  const handleBantuanClick = () => {
    const userRoleId = session.roles;

    const priorityRoles = [40, 42, 43, 44, 1, 3];

    const sortedRoleCheckPaths = roleCheckPaths.sort(
      ({ roleIds: a }, { roleIds: b }) => {
        const aIndex = a.find((roleId) => priorityRoles.includes(roleId));
        const bIndex = b.find((roleId) => priorityRoles.includes(roleId));
        return priorityRoles.indexOf(aIndex) - priorityRoles.indexOf(bIndex);
      }
    );

    const path = sortedRoleCheckPaths.find(({ roleIds }) =>
      roleIds.some((roleId) => userRoleId.includes(roleId))
    )?.path;
    console.log(path);
    if (path) {
      window.location.href = "/akreditasi" + path + "/bantuan";
      // router.push(path);
    } else {
      window.location.href = "/akreditasi";
    }
  };
  useEffect(() => {
    if (
      status != "loading" &&
      session &&
      session?.error === "RefreshAccessTokenError"
    ) {
      signOut({ callbackUrl: "/" });
    }
  }, [session, status]);

  if (session && session.user) {
    return (
      <div className="flex self-center gap-4 ml-auto">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Avatar className={cn("bg-customRed cursor-pointer")}>
              <AvatarImage src={session.user.picture} />
              <AvatarFallback className={cn("text-white")}>
                {getInitials(session.user.name)}
              </AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent alignOffset={-10} align="end">
            <div className="px-5 py-3">
              <div className="flex flex-row mb-4 gap-x-2">
                <div>
                  <Avatar className={cn("bg-customRed text-white")}>
                    <AvatarImage src={session.user.picture} />
                    <AvatarFallback>
                      {getInitials(session.user.name)}
                    </AvatarFallback>
                  </Avatar>
                </div>
                <div className="flex flex-col">
                  <p className="text-sm font-bold">Hi, {session.user.name}</p>
                  <p className="text-xs overflow-ellipsis truncate">
                    {session.user.email.length > 22
                      ? session.user.email.substring(0, 22) + "..."
                      : session.user.email}
                  </p>
                </div>
              </div>
              <div>
                <div
                  onClick={handleDashboardClick}
                  className="flex flex-row self-center text-gray-600 cursor-pointer text-md gap-x-2 hover:text-black"
                >
                  <FaHome className="mt-1" />
                  <p>Halaman Utama</p>
                </div>
                <div
                  onClick={handleBantuanClick}
                  className="flex flex-row self-center text-gray-600 cursor-pointer text-md gap-x-2 hover:text-black"
                >
                  <IoIosHelpCircle className="mt-1" />
                  <p>Bantuan</p>
                </div>
                <div className="flex flex-row self-center text-gray-600 cursor-pointer text-md gap-x-2 hover:text-black">
                  <Dialog>
                    <DialogTrigger asChild>
                      <div className="flex gap-x-2">
                        <MdLogout className="mt-1" />

                        <p>Keluar</p>
                      </div>
                    </DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Konfirmasi Logout</DialogTitle>
                        <DialogDescription>
                          Apakah Anda yakin ingin keluar?
                        </DialogDescription>
                      </DialogHeader>
                      <DialogFooter className="mt-3">
                        <Button variant="rejected">Tidak</Button>
                        <Button
                          disabled={isLoading}
                          variant="destructive"
                          onClick={async () => {
                            setIsLoading(true);
                            await fetch(`${API_USR_URL}/principal/logout`, {
                              method: "POST",
                              headers: {
                                Authorization: "Bearer " + session.access_token,
                                Accept: "application/json",
                                "Content-Type": "application/json",
                              },
                            }).then((res) => {
                              return res;
                            });
                            await signOut({ callbackUrl: "/akreditasi" });
                          }}
                        >
                          {isLoading ? "Memuat..." : "Iya, Keluar"}
                        </Button>
                      </DialogFooter>
                    </DialogContent>
                  </Dialog>
                </div>
              </div>
            </div>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  }
  return status === "loading" ? (
    <button
      className="flex self-center px-3 py-2 ml-auto text-white transition-transform duration-200 ease-in-out shadow-lg rounded-xl bg-customGreen"
      disabled
    >
      Memuat...
    </button>
  ) : (
    <Link href="/login">
      <span className="flex self-center px-3 py-2 ml-auto text-white transition-transform duration-200 ease-in-out shadow-lg rounded-xl bg-customGreen hover:scale-110">
        Masuk
      </span>
    </Link>
  );
}
